/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import { createSelector } from 'reselect';

import brandThemes from '../../../../../app/components/AppShell/brandtheme';

export const getCurrentBrandId = (state) => state.ui?.brandId;
export const getConfigByDomains = (state) => state.app?.config?.byDomain;

export const getBrandsById = (state) => {
    if (state && state.page && state.page.brands && state.page.brands.byId) {
        return state.page.brands.byId;
    }

    return null;
};

const brandByDomain = {
    '18F': '1800flowers',
    HD: 'harryanddavid',
    '18B': '1800baskets',
    SCH: 'simplychocolate',
    FBQ: 'fruitbouquets',
    CCO: 'cheryls',
    PZU: 'personalizationuniverse',
    TPF: 'thepopcornfactory',
    WLF: 'wolfermans',
    SY: 'stockyards',
    BRY: 'berries',
    '08F': '0800flowers',
    CAN: 'canada',
    PLA: 'plants',
};

// Brand Details
export const getBrand = createSelector(
    [
        getCurrentBrandId,
        getBrandsById,
    ],
    (currentBrandId, configCodes) => {
        if (currentBrandId && configCodes[currentBrandId]) {
            return configCodes[currentBrandId];
        }
        return null;
    },
);

// Feature Flag
export const getFeatureFlags = createSelector(
    [getCurrentBrandId, getConfigByDomains],
    (currentBrandId, configCodes) => {
        if (
            currentBrandId
      && brandByDomain[currentBrandId]
      && configCodes[brandByDomain[currentBrandId]]
        ) {
            return configCodes[brandByDomain[currentBrandId]]['app-feature-flags'];
        }

        return {};
    },
);

export const getBestSellersId = createSelector(
    [
        getBrand,
    ],
    (currentBrand) => {
        const { code } = currentBrand || {};
        if (code) {
            const { best_sellers_category_id } = currentBrand;
            return best_sellers_category_id;
        }
        return '';
    },
);

export const getPresentationFamily = createSelector(
    [
        getBrand,
    ],
    (currentBrand) => {
        if (currentBrand && currentBrand.code) {
            const { presentation_family } = brandThemes[brandThemes[currentBrand.code] ? currentBrand.code : '18F'];
            return presentation_family;
        }

        return null;
    },
);

export const getDisplayDeliveryMethod = createSelector(
    [
        getBrand,
    ],
    (currentBrand) => {
        if (currentBrand && currentBrand.code) {
            const { implement_delivery_method } = brandThemes[brandThemes[currentBrand.code] ? currentBrand.code : '18F'];
            return implement_delivery_method;
        }

        return null;
    },
);

export const getDisplayAdditionalCompliance = createSelector(
    [
        getBrand,
    ],
    (currentBrand) => {
        if (currentBrand && currentBrand.code) {
            const { implement_additional_compliance_age_verify } = brandThemes[brandThemes[currentBrand.code] ? currentBrand.code : '18F'];
            return implement_additional_compliance_age_verify;
        }

        return null;
    },
);

export const getPriceRangeLayout = createSelector(
    [
        getBrand,
    ],
    (currentBrand) => {
        const { code } = currentBrand || {};
        if (code) {
            const { price_range_layout } = brandThemes[code] || brandThemes['18F'];
            return price_range_layout;
        }
        return '';
    },
);

export const getFeatureFlag = (selector) => createSelector(
    [getFeatureFlags],
    (featureFlags) => {
        if (Array.isArray(selector)) {
            let result = featureFlags;
            // eslint-disable-next-line consistent-return
            selector.forEach((propertyName) => {
                // eslint-disable-next-line no-prototype-builtins
                if (!result?.hasOwnProperty || !result.hasOwnProperty(propertyName)) {
                    return false;
                }
                result = result[propertyName];
            });

            return result;
        }

        if (featureFlags) {
            return featureFlags[selector] ?? false;
        }

        return false;
    },
);

export const getPassportPageUrl = (state) => state.checkout?.payment?.passport?.passportData?.url || '/passport-flowers';
